<template>
  <div>
    <div class="columns">
      <div class="column has-text-centered">
          <h1 class="is-size-3 has-text-white">SPARE PARTS MANAGER</h1>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <section class="section">
          <b-field grouped group-multiline>
            <b-select v-model="perPage" :disabled="!isPaginated">
                <option value="5">5 per page</option>
                <option value="10">10 per page</option>
                <option value="15">15 per page</option>
                <option selected value="20">20 per page</option>
            </b-select>
            <b-button class="button is-dvogreen"
                @click="addModal()">
                New Part
            </b-button>
        </b-field>
            <b-table :data="parts"  paginated :per-page="perPage" :current-page.sync="currentPage"
                :pagination-simple="false" pagination-position="bottom" :loading="isLoading" striped>
                  <b-table-column field="number" label="Number" width="40" searchable v-slot="props">
                    <router-link
                      :to="{ name: 'Part', params: { id: props.row.number }}"
                    >
                      {{ props.row.number }}
                    </router-link>
                  </b-table-column>
                  <b-table-column field="description" label="Description" width="40" searchable v-slot="props">
                      {{ props.row.description }}
                  </b-table-column>
                  <b-table-column field="distributor_cost" label="Distributor Cost" width="40" numeric sortable v-slot="props">
                      ${{ props.row.distributor_cost }}
                  </b-table-column>
                  <b-table-column field="dealer_cost" label="Dealer Cost" width="40" numeric sortable v-slot="props">
                      ${{ props.row.dealer_cost }}
                  </b-table-column>
                  <b-table-column field="manufacture_cost" label="Manufacture Cost" width="40" numeric sortable v-slot="props">
                      ${{ props.row.manufacture_cost }}
                  </b-table-column>
                  <b-table-column field="msrp" label="MSRP" width="40" numeric sortable v-slot="props">
                      ${{ props.row.msrp}}
                  </b-table-column>
                  <b-table-column field="number" label="Edit" width="20" numeric v-slot="props">
                    <i @click="updateModal(props.row.number, props.row.description, props.row.distributor_cost, props.row.dealer_cost, props.row.manufacture_cost, props.row.msrp)" class="fas fa-edit has-text-dvogreen"></i>  
                  </b-table-column>
                  <b-table-column field="number" label="Delete" width="20" numeric v-slot="props">
                    <i @click="deletePart(props.row.number)" class="far fa-trash-alt has-text-dvogreen"></i> 
                  </b-table-column>
            </b-table>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { deletePart } from '../../graphql/mutations'
import { getParts} from '../../graphql/queries';
import AddPart from './AddPart.vue';
import UpdatePart from './UpdatePart.vue';
    
export default {
  components:{
  },
  data(){
    return{
      parts:[],
      currentPage: 1,
      perPage: 20,
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      isLoading: false
      
    }
  },
  methods: {
  async getParts() {
    this.isLoading = true
    try {
    const Parts = await API.graphql({
      query: getParts
    });
    this.parts = Parts.data.getParts;
    } catch (e) {
        this.$buefy.notification.open({
          duration: 5000,
          message: `${e}`,
          position: 'is-bottom',
          type: 'is-danger',
          hasIcon: true
      })
    }
    this.isLoading = false;
    },
  async deletePart(number) {
    const apiReturn = await API.graphql({
      query: deletePart,
      variables: { 
        input: 
            {
            number: number
            }
      }
    });
    const temp = apiReturn.data.deletePart
    this.parts = this.parts.filter(obj => obj.number != temp.number);
  },
  addModal() {
        this.$buefy.modal.open({
            parent: this,
            component: AddPart,
            hasModalCard: true,
            trapFocus: true,
            events: {
              'close': value => {
                this.parts.push(value);
                this.getParts()
              }
            }
        })
    },
  updateModal(number, description, distributor_cost, dealer_cost, manufacture_cost, msrp) {
        this.$buefy.modal.open({
            parent: this,
            component: UpdatePart,
            trapFocus: true,
            fullScreen: true,
            props:{
              initNumber: number,
              initDescription: description,
              initDistributorCost: distributor_cost,
              initDealerCost: dealer_cost,
              initManufactureCost: manufacture_cost,
              initMsrp: msrp
            },
            events: {
              'close': value => {
                console.log(value)
                this.getParts()
              }
            }
        })
    }
  },
  async mounted() { 
  this.getParts()
  },
}
</script>

<style>
i{
  cursor: pointer;
}
.pagination-link{
  color: white !important;
}
</style>